<template>
  <v-list-item
    v-if="
      (item.access !== undefined ? item.access : true) &&
      (item.hidden ? $vuetify.breakpoint.width > item.hidden : true)
    "
    :to="!item.fullScreen ? { name: item.toName } : null"
    @click="item.fullScreen ? click() : null"
    :class="drawerShow ? 'show' : ''"
    :style="'animation-delay:' + delay / 10 + 's'"
  >
    <v-avatar v-if="child" size="40" color="#6AB1D8" class="pa-2">
      <BaseIcon v-if="item.icon" :icon="item.icon" color="#ffffff" width="24" height="24" />
    </v-avatar>
    <template v-else>
      <BaseIcon v-if="item.icon" :icon="item.icon" color="#ffffff" width="24" height="24" />
    </template>
    <span class="white--text">
      {{ item.text }}
    </span>
  </v-list-item>
</template>

<script>
export default {
  name: 'HeaderMobileMenuListItem',
  props: {
    item: Object,
    drawerShow: [Object, Boolean],
    delay: [Function, String, Number],
    child: Boolean,
  },
  data() {
    return {
      fullScreen: null,
    }
  },
  computed: {
    parent() {
      return this.$parent.$parent
    },
  },
  methods: {
    click() {
      console.log(this.item)
      this.$emit('getFullScreen', this.item)
    },
  },
}
</script>
